module.exports = __webpack_public_path__ + "static/media/readmegenimg.a7d56ba2.jpg";